import React from 'react';

import { Form } from 'antd';

import { Button } from '@components/Element/Button';
import { Input, InputResend } from '@components/Element/Input';
import WapperModal from '@components/WapperModal';
// import { useRouter } from 'next/router';
// import NoCaptchaModal from '@components/NoCaptchaModal';
import I18n from '@utils/i18n';

import safetyStyles from '@styleModules/safety.module.css';

export default function Modal (props) {
  const {
    modalVisible,
    verifyTypes: { email, phone, google },
    closeModal,
    onResend,
    loginDisabledFn,
    onFinish,
    state,
    dispatch
  } = props
  // const router = useRouter()
  const [form] = Form.useForm();
  const { isCountDown, isCountDownEmail } = state

  return (
    <WapperModal
      visible={modalVisible}
      title={I18n.t('login_twice_verification')}
      maskClosable={false}
      // width={640}
      form={form}
      wrapClassName={safetyStyles.modal}
      onCancel={() => { closeModal(form) }}
    >
      <div className={safetyStyles.main}>
        <p className={safetyStyles.title}>{I18n.t('login_twice_verification')}</p>
        <br /><br />
        <div className={safetyStyles.verifyContent}>
          <Form
            form={form}
            onFinish={(value) => { onFinish(value, form) }} autocomplete="off">
            <div className={safetyStyles.Input}>
              {
                email && (
                  <Form.Item
                    name="emailVerifyCode"
                    rules={[
                      {
                        required: true,
                        message: I18n.t('user_login_relate_widget_password_emailverifycode')
                      }
                    ]}
                  >
                    <InputResend
                      placeholder={I18n.t('user_login_relate_widget_password_emailverifycode')}
                      onSend={() => { onResend('mail') }}
                      setCountDown={(v) => {
                        dispatch({
                          type: 'update',
                          payload: {
                            isCountDownEmail: v
                          }
                        })
                      }}
                      countdown={isCountDownEmail}
                    />
                  </Form.Item>
                )
              }
              {
                phone && (
                  <Form.Item
                    name="smsVerifyCode"
                    rules={[
                      {
                        required: true,
                        message: I18n.t('user_login_relate_widget_password_phoneverifycode')
                      }
                    ]}
                  >
                    <InputResend
                      placeholder={I18n.t('user_login_relate_widget_password_phoneverifycode')}
                      setCountDown={(v) => {
                        dispatch({
                          type: 'update',
                          payload: {
                            isCountDown: v
                          }
                        })
                      }}
                      onSend={() => { onResend('phone') }}
                      countdown={isCountDown}
                    />
                  </Form.Item>
                )
              }
              {
                google && (
                  <Form.Item
                    name="googleVerifyCode"
                    rules={[
                      {
                        required: true,
                        message: I18n.t('user_login_relate_widget_password_googleverifycode')
                      }
                    ]}
                  >
                    <Input
                      id="goglecode"
                      placeholder={I18n.t('user_login_relate_widget_password_googleverifycode')}
                      onSend={onResend}
                    // countdown={isCountDown}
                    />
                  </Form.Item>
                )
              }
            </div>
            <Form.Item
              noStyle
              shouldUpdate
            >
              {(form) => {
                return (
                  <Button
                    disabled={!loginDisabledFn(form)}
                    type="primary"
                    htmlType="submit"
                  >
                    {I18n.t('user_login_relate_widget_phone_confim')}
                  </Button>
                )
              }}
            </Form.Item>
          </Form>
        </div>
      </div>
    </WapperModal>
  )
}
